import { Column } from '@/components'
import { toThemePixels } from '@/utils'
import styled from 'styled-components'

export const PageHeader = styled(Column)`
  gap: ${toThemePixels(4)};
  margin-bottom: ${toThemePixels(8)};
`
